

export class FuelStationStatusInput implements IFuelStationStatusInput {
    /** The auto-generated id of the fuel station master */
    fuelStationId!: number;
    /** The updated status */
    status!: number;

    constructor(data?: IFuelStationStatusInput) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.fuelStationId = _data["fuelStationId"];
            this.status = _data["status"];
        }
    }

    static fromJS(data: any): FuelStationStatusInput {
        data = typeof data === 'object' ? data : {};
        let result = new FuelStationStatusInput();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["fuelStationId"] = this.fuelStationId;
        data["status"] = this.status;
        return data; 
    }
}

export interface IFuelStationStatusInput {
    /** The auto-generated id of the fuel station master */
    fuelStationId: number;
    /** The updated status */
    status: number;
}

